<template>
  <div class="page-shell">
    <PageBanner
      eyebrow="CASE DETAIL"
      background-image="/page/cases-banner.jpg"
      :title="caseInfo.title"
      :subtitle="caseInfo.summary"
    />

    <section class="section">
      <div class="container detail-shell">
        <router-link class="back-link" to="/cases">
          <span aria-hidden="true">&lt;</span>
          {{ $pick({ "zh-CN": "返回工程案例", "en-US": "Back to Cases" }) }}
        </router-link>

        <div class="detail-hero">
          <figure v-reveal class="detail-image">
            <img :src="caseInfo.image" :alt="$pick(caseInfo.title)" />
          </figure>

          <article v-reveal class="detail-copy">
            <p class="eyebrow">{{ $pick(caseInfo.category) }}</p>
            <h1>{{ $pick(caseInfo.title) }}</h1>
            <p class="summary">{{ $pick(caseInfo.summary) }}</p>
            <p class="description">{{ $pick(caseInfo.description) }}</p>
          </article>
        </div>

        <div class="case-points">
          <div v-for="point in caseInfo.points" :key="$pick(point)" v-reveal class="point-card">
            {{ $pick(point) }}
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";
import { getCaseBySlug } from "../../data/site";

export default {
  name: "CaseDetailPage",
  components: { PageBanner },
  computed: {
    caseInfo() {
      return getCaseBySlug(this.$route.params.slug) || {
        title: { "zh-CN": "工程案例", "en-US": "Project Case" },
        category: { "zh-CN": "案例详情", "en-US": "Case Detail" },
        summary: { "zh-CN": "暂未找到该案例信息。", "en-US": "Case information was not found." },
        description: { "zh-CN": "请返回工程案例页面重新选择。", "en-US": "Please return to the cases page and choose again." },
        points: [],
        image: "/page/cases-banner.jpg"
      };
    }
  }
};
</script>

<style scoped>
.detail-shell {
  display: grid;
  gap: 26px;
}

.back-link {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: var(--brand-blue);
  background: #eef5fb;
  border: 1px solid rgba(18, 95, 166, 0.18);
  font-weight: 700;
}

.back-link:hover {
  color: #fff;
  background: var(--brand-blue);
}

.detail-hero {
  display: grid;
  grid-template-columns: minmax(360px, 1.06fr) minmax(360px, 0.94fr);
  gap: 34px;
  align-items: stretch;
}

.detail-image {
  margin: 0;
  padding: 8px;
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
}

.detail-image img {
  width: 100%;
  height: 100%;
  min-height: 430px;
  object-fit: cover;
  background: #eef3f8;
}

.detail-copy {
  position: relative;
  padding: 38px;
  background:
    linear-gradient(135deg, rgba(13, 103, 206, 0.08), rgba(255, 255, 255, 0) 45%),
    #fff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
}

.detail-copy::before {
  content: "";
  display: block;
  width: 58px;
  height: 4px;
  margin-bottom: 22px;
  background: linear-gradient(90deg, #0d6fda, #35b7ff);
}

.eyebrow {
  margin: 0 0 10px;
  color: var(--brand-blue);
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.detail-copy h1 {
  margin: 0;
  color: var(--brand-blue-deep);
  font-size: clamp(32px, 4vw, 48px);
  line-height: 1.16;
}

.summary {
  margin: 20px 0 0;
  color: #27384e;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.8;
}

.description {
  margin: 18px 0 0;
  color: #596678;
  line-height: 2;
}

.case-points {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.point-card {
  min-height: 116px;
  padding: 22px;
  color: #34455b;
  background: #fff;
  border: 1px solid var(--line);
  border-top: 3px solid var(--brand-blue);
  box-shadow: 0 14px 34px rgba(18, 54, 110, 0.08);
  line-height: 1.8;
}

@media (max-width: 900px) {
  .detail-hero,
  .case-points {
    grid-template-columns: 1fr;
  }

  .detail-image img {
    min-height: 300px;
  }
}

@media (max-width: 560px) {
  .detail-copy,
  .point-card {
    padding: 20px;
  }

  .detail-copy h1 {
    font-size: 30px;
  }
}
</style>
